import update from 'immutability-helper'
import { SET_TEMPLATELIST } from '../constants'
const InitState = {
  templateList: [],
}

export default function (state = InitState, action: any) {
  switch (action.type) {
    case SET_TEMPLATELIST:
      return update(state, {
        templateList: {
          $set: action.templateList,
        },
      })
    default:
      return state
  }
}
